import { render, staticRenderFns } from "./ResultDetails.vue?vue&type=template&id=1734aa3c"
import script from "./ResultDetails.vue?vue&type=script&lang=js"
export * from "./ResultDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports